import React, { useState } from 'react';
import {
  Page,
  Navbar,
  List,
  ListInput,
  Button,
  Block,
  Row,
  Col,
  BlockHeader
} from 'framework7-react';
import axios from 'axios';

const ProfileUpdatePage = () => {
  const [restaurantname, setRestaurantName] = useState('');
  const [ownerfirstname, setOwnerFirstName] = useState('');
  const [ownerlastname, setOwnerLastName] = useState('');  
  const [ein, setEIN] = useState('');
  const [address1, setAddress1] = useState('');
  const [address2, setAddress2] = useState('');  
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [zipcode, setZipCode] = useState('');  
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.put('/api/profile', {
        restaurantname,
        ownerfirstname,
        ownerlastname,
        ein,
        address1,
        address2,
        city,
        state,
        zipcode,
        email,
        phone,
      });
      console.log(response.data); // handle successful response
    } catch (error) {
      console.error(error); // handle error
    }
  };

  return (
    <Page className='bg-white'>
      <Navbar title="Restaurant Information" backLink="Back" noShadow/>            
      <form onSubmit={handleSubmit}>
        <BlockHeader>Restaurant Details</BlockHeader>
        <List noHairlinesMd>
          <ListInput
            label="Restaurant Name"
            type="text"
            required
            pattern="[a-zA-Z0-9 ]*"
            placeholder="Restaurant Name"
            value={restaurantname}
            onInput={(event) => setRestaurantName(event.target.value)}
          />
          <ListInput
            label="Owner First Name"
            type="text"
            required
            placeholder="Owner First Name"
            value={ownerfirstname}
            onInput={(event) => setOwnerFirstName(event.target.value)}
          />
          <ListInput
            label="Owner Last Name"
            type="text"
            placeholder="Owner Last Name"
            value={ownerlastname}
            onInput={(event) => setOwnerLastName(event.target.value)}
          />
          <ListInput
            label="Restaurant EIN"
            type="text"
            placeholder="Restaurant EIN"
            value={ein}
            required
            validate
            pattern="[0-9]*"
            onInput={(event) => setEIN(event.target.value)}
          />
        </List>
        <List noHairlinesMd>
          <BlockHeader>Address Details</BlockHeader>
          <ListInput
            label="Address"
            type="text"
            required
            placeholder="Restaurant address"
            value={address1}
            onInput={(event) => setAddress1(event.target.value)}
          />
          <ListInput
            label="Address 2"
            type="text"
            required
            placeholder="Restaurant address 2"
            value={address2}
            onInput={(event) => setAddress2(event.target.value)}
          />
          <ListInput
            label="City"
            type="text"
            readonly={true}
            placeholder="City"
            value={city}
            onInput={(event) => setCity(event.target.value)}
          />
          <ListInput
            label="State"
            type="text"
            readonly={true}
            placeholder="State"
            value={state}
            onInput={(event) => setState(event.target.value)}
          />
          <ListInput
            label="Email"
            type="email"
            readonly={true}
            placeholder="Your email"
            value={email}
            onInput={(event) => setEmail(event.target.value)}
          />
          <ListInput
            label="Phone"
            type="text"
            placeholder="Your Phone Number"
            value={phone}
            required
            validate
            pattern="[0-9]*"
            onInput={(event) => setPhone(event.target.value)}
          />
          <ListInput
            label="Zip Code"
            type="text"
            placeholder="Zip Code"
            value={zipcode}
            required
            validate
            pattern="[0-9]*"
            onInput={(event) => setZipCode(event.target.value)}
          />                    
          <Block>
            <Row>
              <Col>
                <Button type="submit" fill large raised>
                  Update Restaurant
                </Button>
              </Col>
            </Row>
          </Block>
        </List>
      </form>
    </Page>
  );
}

export default ProfileUpdatePage;